import * as React from "react";
// 消息查询表单
import NoticeSearchForm from "widget/notice/noticeSearchForm";
// tab栏
import TabBar from "widget/notice/tabbar";
// 消息列表
import NoticeList from "widget/notice/noticeList";
// 提及
import { Mention, Button, message } from "antd";
// 编辑器
import SimpleEditor from "widget/editor";
// 浏览器消息
import BrowserNotice from "widget/notice/browserNotice";

//import { Editor, EditorState } from "draft-js";
// 消息枚举
import { ENoticeType } from "utils/enum/notice";
// 工具库：判断是否包含属性并返回原值或默认值
import { getPropertysValues } from "utils/tool";

import cuid from "cuid";

import "styles/noticePanel.scss";

const noticePanel = "noticePanel";

//const Nav = Mention.Nav;

const { getMentions } = Mention;

// 消息面板
class NoticePanel extends React.PureComponent<any, any> {
  state = {
    form: {
      // 开始日期
      beginDate: null,
      // 结束日期
      endDate: null,
      // 关键字
      keys: null
    },
    // 清除列表
    isClearList: false,
    // 消息类型 默认：全部
    noticeListType: ENoticeType.All,
    // 是否获取更多的数据
    isGetMore: true,
    // 消息列表Ref
    noticeListRef: null,
    // 客服发送列表
    userSendList: [],
    // 群组发送列表
    groupSendList: [],
    // 全部发送
    allSend: null,
    // 消息面板Ref
    noticePanelRef: null,
    // 编辑器Ref
    editorRef: null
  };

  constructor(props: any) {
    super(props);
  }

  componentWillMount() {
    // 获取消息列表
    this.getList(1);
    // 获取未读消息数目
    this.props.getUnReadCount();
    this.props.getUnReadCountWithParams({});
    // 获取客服列表
    this.props.getUserList();
    // 更新当前选中的tab | type
    this.props.updNoticeCType(ENoticeType.All);
    // this.props.getNoticeList();
  }

  // 获取redux中保存的数据
  getValue = args => {
    const modelName = noticePanel;
    const data = this.props.reduxData[modelName];

    let getValue = field => {
      if (data) {
        return data[field] || null;
      } else {
        getValue = () => {
          return null;
        };
        return null;
      }
    };

    if (typeof args === "string") {
      return getValue(args);
    } else if (args instanceof Array) {
      const dateRange: any = [];
      for (const item of args) {
        dateRange.push(getValue(item));
      }
      return dateRange;
    } else {
      return null;
    }
  };

  // 获取当前的消息数据
  getCurrentNoticeList = () => {
    const noticeType = this.state.noticeListType || ENoticeType.All;
    let noticeList = [];
    switch (noticeType) {
      case ENoticeType.All:
        console.log("this.props.allNotice", this.props.allNotice);
        noticeList = this.props.allNotice;
        break;
      case ENoticeType.Unread:
        noticeList = this.props.unReadNotice;
        break;
      case ENoticeType.Collect:
        noticeList = this.props.collectNotice;
        break;
      default:
        noticeList = this.props.allNotice;
        break;
    }
    return noticeList;
  };

  // 获取当前选中tabIndex
  getTabeIndex = key => {
    let isGetMore = true,
      states = {};

    // 判断NoticeList是否需要获取更多的数据
    // if (key == ENoticeType.All) {
    //   isGetMore = true;
    // } else {
    //   isGetMore = false;
    // }

    // 当消息类型变化时才更新
    if (key != this.state.noticeListType) {
      states = { ...states, noticeListType: key };
    }

    // 初始化页面state数据
    const reduxData = this.props.reduxData[noticePanel];
    const { beginDate, endDate, keys } = getPropertysValues(reduxData || [], [
      "beginDate",
      "endDate",
      "keys"
    ]);
    this.setState(
      {
        ...states,
        form: {
          beginDate,
          endDate,
          keys
        },
        isGetMore,
        isClearList: true
      },
      () => {
        console.log("getTabeIndex");
        // 更新消息列表 search 查询需要从第一页开始查
        this.getList(1);
        this.setState({
          isClearList: false
        });

        // 获取未读消息数目
        const form = this.state.form;
        this.props.getUnReadCountWithParams({
          search: form.keys,
          start: form.beginDate,
          end: form.endDate
        });
      }
    );

    // 更新当前选中的tab | type
    this.props.updNoticeCType(key);

    // 获取未读消息数目
    // this.props.getUnReadCount();
  };

  getList = page => {
    console.log("page", page);
    const form = this.state.form;
    this.props.getNoticeList({
      type: this.state.noticeListType,
      page,
      start: form.beginDate,
      end: form.endDate,
      search: (form.keys || "").trim(),
      callback: data => {
        if (data && !data.error && (data.length == 0 || data.length <= 5)) {
          this.setState({
            isGetMore: false
          });
        }
      }
    });
  };

  // 查询
  onSearch = () => {
    // 初始化页面state数据
    const reduxData = this.props.reduxData[noticePanel];
    const { beginDate, endDate, keys } = getPropertysValues(reduxData || [], [
      "beginDate",
      "endDate",
      "keys"
    ]);

    this.setState(
      {
        form: {
          beginDate,
          endDate,
          keys
        },
        isGetMore: true,
        isClearList: true
      },
      () => {
        const noticeListRef: any = this.state.noticeListRef;
        if (noticeListRef) noticeListRef.forceUpdate();
        this.setState({
          isClearList: false
        });
        this.getList(1);

        // 获取未读消息数目
        const form = this.state.form;
        this.props.getUnReadCountWithParams({
          search: form.keys,
          start: form.beginDate,
          end: form.endDate
        });
      }
    );
  };

  // 重置并查询列表
  onResetSearch = () => {
    this.setState(
      {
        form: {
          beginDate: null,
          endDate: null,
          keys: null
        },
        isGetMore: true,
        isClearList: true
      },
      () => {
        const noticeListRef: any = this.state.noticeListRef;
        if (noticeListRef) noticeListRef.forceUpdate();
        this.setState({
          isClearList: false
        });
        this.getList(1);

        // 获取未读消息数目
        const form = this.state.form;
        this.props.getUnReadCountWithParams({
          search: form.keys,
          start: form.beginDate,
          end: form.endDate
        });
      }
    );
  };

  getNoticeListRef = ref => {
    // this.setState({
    //   noticeListRef: ref
    // });

    // 更新当前消息面板的ref
    this.props.updNoticePanel(ref.returnToTop);
  };

  editorFocus = null;
  // 获取编辑器 获取焦点的方法
  getEditorFocus = focus => {
    this.editorFocus = focus;
  };

  // 获取编辑器ref
  getEditorRef = ref => {
    this.setState({
      editorRef: ref
    });
  };

  // 给编辑器设置焦点
  focus = () => {
    const editorFocus: any = this.editorFocus;
    editorFocus && editorFocus();
  };

  // 标记全部已读
  markedAllRead = () => {
    // params.type = this.state.noticeListType;
    const params: any = {
      uid: true
    };
    params.callback = data => {
      if (data && !data.error) this.forceUpdate();
    };
    this.props.tagAllRead(params);
  };

  renderMarkedAllRead = () => {
    const { unReadNotice } = this.props;
    // 当Tab栏选中的是未读时显示全部标记
    if (
      this.state.noticeListType === ENoticeType.Unread &&
      unReadNotice &&
      unReadNotice.length > 0
    ) {
      return (
        <a onClick={this.markedAllRead}>
          全部标记已读
        </a>
      );
    }
    return [];
  };

  onSelect = (suggestion, data) => {
    console.log("onSelect", suggestion, data);
  };

  // 提及 输入改变事件，在这里可以获得当前已选择的客服，客服群组
  onMentionChange = contentState => {
    const cg = getMentions(contentState);
    const userList: any = [],
      groupList: any = [];
    let allSend: any = null;
    if (cg.length > 0) {
      let res = false;
      for (const item of this.props.suggestions) {
        res = cg.some(ele => {
          return "@" + item.name === ele;
        });
        if (res) {
          // 接口文档上描述的是type,
          switch (item.mtype) {
            case "user":
              userList.push(item.id);
              break;
            case "group":
              groupList.push(item.id);
              break;
            case "all":
              allSend = "all";
              break;
            default:
              break;
          }
        }
      }
    }

    this.setState({
      userSendList: userList,
      groupSendList: groupList,
      allSend: allSend
    });
  };

  setNoticePanelRef = ref => {
    this.setState({
      noticePanelRef: ref
    });
  };

  getNoticePanelRef = () => {
    return this.state.noticePanelRef || document.body;
  };

  // 标记已读
  tagRead = params => {
    params.type = this.state.noticeListType;
    params.callback = data => {
      if (data && !data.error) {
        //this.forceUpdate();
      }
    };
    this.props.tagRead(params);
  };

  // 标记收藏
  tagCollect = params => {
    params.type = this.state.noticeListType;
    params.callback = data => {
      // if (data && !data.error) this.forceUpdate();
    };
    this.props.tagCollect(params);
  };

  // 上传附件
  onFileChange = event => {
    const input = event.target;
    // console.log(input)
    const files = input.files;
    if (files && files.length > 0) {
      const file = files[0];
      console.log(file);
      const fileSize = file.size;
      let size = fileSize / 1024;
      let type = file.type;
      if (type.indexOf("image/") != -1) {
        if (size > 1024) {
          message.warn("图片不能大于1M");
          input.value = "";
          return;
        }
      } else {
        if (size > 1024 * 10) {
          message.warn("附件不能大于10M");
          input.value = "";
          return;
        }
      }

      this.props.uploadFile({
        file: files[0],
        error: text => {
          message.error(text);
        },
        success: ({ name, type, url }) => {
          const editorRef: any = this.state.editorRef;
          editorRef && editorRef.addEntity(url, type, name);
          input.value = "";
        }
      });
    }
  };

  getUserName = (id, type) => {
    const suggestions = this.props.suggestions;
    if (type == "all") {
      return "全部";
    } else if (suggestions) {
      const userInfo: any = suggestions.find((item: any) => {
        return item.id == id && item.mtype === type;
      });

      if (userInfo) {
        return userInfo.name;
      } else {
        return "-";
      }
    } else {
      return "-";
    }
  };

  // 构造数据
  buildData1 = (type, data, msg) => {
    let res = false;
    if (data && data.length > 0) {
      console.log("buildData", type);
      console.log("buildData", data);
      const dataJson = {
        type,
        id: type != "all" ? data.join() : "",
        msg: JSON.stringify(msg)
      };
      console.log(dataJson);
      this.props.sendNotice({
        data: dataJson,
        callback: _data => {
          if (_data && !_data.error) {
            console.log("buildData", data);
            const _addNotice = item => {
              // 把发送的消息添加到面板中
              this.props.addNotice({
                type: 99, //表示临时添加的消息
                isPopup: false,
                create_time: parseInt((new Date().getTime() / 1000).toString()),
                content: JSON.stringify(msg),
                to: this.getUserName(item, type),
                from: "我",
                mid: cuid()
              });
            };

            if (type === "all") {
              _addNotice("all");
            } else {
              for (const item of data) {
                _addNotice(item);
              }
            }
          }
        }
      });
    }
    return res;
  };

  // 发送websoket消息
  buildData = (type, data, msg) => {
    if (data && data.length > 0) {
      for (const item of data) {
        this.sendMsg(type, item, msg);
      }
    }
  };

  // 对全部发送消息
  sendAllMsg = (type, data, msg) => {
    if (data) this.sendMsg(type, data, msg);
  };

  // 发送消息
  sendMsg = (type, item, msg) => {
    const dataJson = {
      type,
      id: item,
      msg: JSON.stringify(msg)
    };
    this.props.sendNotice({
      data: dataJson,
      callback: _data => {
        // 把发送的消息添加到面板中
        this.props.addNotice({
          type: 99, //表示临时添加的消息
          isPopup: false,
          create_time: parseInt((new Date().getTime() / 1000).toString()),
          content: JSON.stringify(msg),
          to: this.getUserName(item, type),
          from: "我",
          mid: cuid()
        });
      }
    });
  };

  // 构造群组数据
  buildGroupData = (type, data, msg) => {
    let res = false;
    if (data && data.length > 0) {
      for (const item of data) {
        this.buildData(type, [item], msg);
      }
    }
    return res;
  };

  // 发布消息
  submitNotice = () => {
    const { userSendList, groupSendList, allSend } = this.state;
    if (
      userSendList.length == 0 &&
      groupSendList.length == 0 &&
      allSend == null
    ) {
      message.warn("请至少选择一项客服或客服群组");
      return;
    }

    const editorRef: any = this.state.editorRef;
    if (editorRef) {
      const editorData = editorRef.getEditorStateRaw();

      // 判断编辑器内容是否有值
      if (SimpleEditor.isEmpty(editorData)) {
        message.warn("发送内容不能为空");
        return;
      }

      this.buildData("user", userSendList, editorData);
      this.buildData("group", groupSendList, editorData);
      this.sendAllMsg("all", allSend, editorData);

      editorRef.reset && editorRef.reset();
      message.success("发布成功");
    } else {
      message.error("发布消息失败");
      console.warn("未获取到编辑器Ref对象");
    }
  };

  // 判断是否允许提交消息
  showSubmitNotice = () => {
    if (this.props.userInfo.submitNotice) {
      const suggestions = (() => {
        const data = this.props.suggestions;
        if (!data) {
          return [];
        } else {
          const navs: any = [];
          data.forEach((ele, index) => {
            navs.push(
              ele.name
              // <Nav value={ele.name} key={index} children={ele.name} data={ele} />
            );
            // navs.push({
            //   value: ele.name,
            //   children: ""
            // });
          });

          return navs;
        }
      })();
      return (
        <React.Fragment>
          <div className="notice-mention">
            <Mention
              style={{ width: "100%" }}
              placeholder="@提及客服群组，客服"
              placement="bottom"
              suggestions={suggestions}
              onSelect={this.onSelect}
              onChange={this.onMentionChange}
              suggestionStyle={{ color: "red" }}
              getSuggestionContainer={this.getNoticePanelRef}
            />
          </div>
          <div className="simpleEditor" onClick={this.focus}>
            <SimpleEditor
              setFocus={this.getEditorFocus}
              setRef={this.getEditorRef}
            />
          </div>
          {/* 发送消息 */}
          <div className="submit-notice">
            <div className="submit-item">
              <a href="javascript:void(0)" style={{ cursor: "pointer" }}>
                <label style={{ cursor: "pointer" }}>
                  <i className="action-user action-fujian" />
                  附件
                  <input
                    type="file"
                    name="SocSecNum"
                    style={{ display: "none" }}
                    accept="image/*, image/*,application/msword,
            application/vnd.openxmlformats-officedocument.wordprocessingml.document,
            application/vnd.ms-excel,	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
            text/plain
            "
                    onChange={this.onFileChange}
                  />
                </label>
              </a>
            </div>
            <div className="submit-item">
              <Button type="primary" onClick={this.submitNotice}>
                发布
              </Button>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return [];
    }
  };

  // 滚动获取列表
  scollGetList = page => {
    // 初始化页面state数据
    const reduxData = this.props.reduxData[noticePanel];
    const { beginDate, endDate, keys } = getPropertysValues(reduxData || [], [
      "beginDate",
      "endDate",
      "keys"
    ]);
    this.setState(
      {
        form: {
          beginDate,
          endDate,
          keys
        }
      },
      () => {
        this.getList(page);
      }
    );
  };

  render() {
    console.log("NoticePanel");
    const noticeListStyle = { height: "calc(100% - 317px)" };
    const { noticeListType } = this.state;
    if (!this.props.userInfo.submitNotice) {
      noticeListStyle.height =
        noticeListType == ENoticeType.Unread
          ? "calc(100% - 130px - 18px)"
          : "calc(100% - 130px)";
    } else {
      noticeListStyle.height =
        noticeListType == ENoticeType.Unread
          ? "calc(100% - 317px -  18px)"
          : "calc(100% - 317px)";
    }

    return (
      <div
        className="notice-panel"
        ref={this.setNoticePanelRef}
        style={{ width: 303 }}
      >
        <BrowserNotice />
        <NoticeSearchForm
          setValue={this.props.setValue}
          getValue={this.getValue}
          modelName={noticePanel}
          onSearch={this.onSearch}
          onResetSearch={this.onResetSearch}
        />
        <TabBar
          setTabIndex={this.getTabeIndex}
          unReadtotal={this.props.unReadCountWithParams}
          collectTotal={0}
        />
        <div className="marked-all-read">{this.renderMarkedAllRead()}</div>
        <NoticeList
          getNoticeList={this.scollGetList}
          tagRead={this.tagRead}
          tagCollect={this.tagCollect}
          hasMore={this.state.isGetMore}
          isClearAllState={this.state.isClearList}
          noticeList={this.getCurrentNoticeList()}
          setRef={this.getNoticeListRef}
          style={noticeListStyle}
        />
        {this.showSubmitNotice()}
      </div>
    );
  }
}

export default NoticePanel;
